/**
 * Comportamiento del control +/− de la tarjeta. Usa window.CasukiCart.cartStore
 * (expuesto por casuki-cart-store.js, cargado antes desde casuki-base.liquid)
 * en vez de un import de módulo, para no depender de un alias en el importmap
 * de Horizon.
 */

class CasukiCartControl extends HTMLElement {
  connectedCallback() {
    this.store = window.CasukiCart && window.CasukiCart.cartStore;
    if (!this.store) return; // Sin JS o sin store: el <form> de siempre sigue funcionando.

    this.variantId = this.dataset.variant;
    this.countEl = this.querySelector('[data-casuki-count]');
    this.liveEl = this.querySelector('[data-casuki-live]');

    this.querySelector('[data-casuki-add]').addEventListener('click', (event) => {
      event.preventDefault(); // el form solo actúa sin JS
      this.store.setQuantity(this.variantId, 1);
      // Que el teclado pueda seguir sumando sin volver a tabular.
      requestAnimationFrame(() => this.querySelector('[data-casuki-inc]').focus());
    });

    this.querySelector('[data-casuki-inc]').addEventListener('click', () => {
      this.store.setQuantity(this.variantId, this.store.quantityFor(this.variantId) + 1);
    });

    this.querySelector('[data-casuki-dec]').addEventListener('click', () => {
      const next = this.store.quantityFor(this.variantId) - 1;
      this.store.setQuantity(this.variantId, next);
      // Al llegar a 0 el stepper desaparece: devolver el foco al botón que vuelve.
      if (next <= 0) requestAnimationFrame(() => this.querySelector('[data-casuki-add]').focus());
    });

    this.onChange = () => this.render();
    this.onError = (event) => this.flashError(event);
    this.store.addEventListener('casuki:cart-change', this.onChange);
    this.store.addEventListener('casuki:cart-error', this.onError);

    this.render();
  }

  disconnectedCallback() {
    if (!this.store) return;
    this.store.removeEventListener('casuki:cart-change', this.onChange);
    this.store.removeEventListener('casuki:cart-error', this.onError);
  }

  render() {
    const quantity = this.store.quantityFor(this.variantId);
    const previous = Number(this.dataset.quantity || 0);
    if (quantity === previous) return;

    this.dataset.quantity = String(quantity);
    this.dataset.state = quantity > 0 ? 'active' : 'idle';
    this.countEl.textContent = String(quantity);
    this.liveEl.textContent = quantity > 0 ? `${quantity} en el carrito` : 'Quitado del carrito';

    // Reinicia la animación del número aunque venga de un cambio anterior.
    this.countEl.classList.remove('is-bumped');
    void this.countEl.offsetWidth;
    this.countEl.classList.add('is-bumped');
  }

  flashError(event) {
    if (event.detail.variantId !== this.variantId) return;
    this.setAttribute('data-error', '');
    setTimeout(() => this.removeAttribute('data-error'), 400);
  }
}

if (!customElements.get('casuki-cart-control')) {
  customElements.define('casuki-cart-control', CasukiCartControl);
}
